import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  ChakraProvider,
  Box,
  ColorModeScript,
  useColorMode,
} from "@chakra-ui/react";
import Login from "./pages/Login";
import Main from "./pages/Main";
import Users from "./pages/Users";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import theme from "./theme";
import "./i18n/i18n"; // Import i18n configuration
import MainServicePopup from "./components/MainServicePopup";

function AppContent() {
  const { colorMode } = useColorMode();

  return (
    <Box minH="100vh" bg={colorMode === "dark" ? "gray.800" : "gray.50"}>
      <Header />
      <Box as="main" flexGrow={1}>
        <Routes>
          <Route path="/" element={<Navigate to="/main" replace />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route path="/main-auth-popup" element={<MainServicePopup />} />
          {/* Add other protected routes here */}
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <Router>
        <AppContent />
      </Router>
    </ChakraProvider>
  );
}

export default App;
